export enum HonorManagerSection {
  Approved = 'approved',
  Pending = 'pending',
  YourRecord = 'your-record',
}
